import React, { createContext, useReducer, useContext } from "react";
import { ACTIONS } from "config";
import { UTILS } from "utils";
import PropTypes from "prop-types";

const initialState = { user: UTILS.getCurrentUser() };
const Store = createContext(initialState);
const { Provider } = Store;

export const useStore = () => useContext(Store);
const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case ACTIONS.UPDATE_CURRENT_USER:
        return { ...state, ...getCurrentUser() };
      case ACTIONS.UPDATE_COUNTER:
        return { ...state, ...icrementCounter(state) };
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

StateProvider.propTypes = {
  children: PropTypes.object,
};

export { StateProvider, Store };

const icrementCounter = (state) => {
  return { counter: state.counter ? state.counter + 1 : 1 };
};

const getCurrentUser = () => {
  return { user: UTILS.getCurrentUser() };
};
